/**
 *  @class
 *  @function ModalDialog
 */
if (!customElements.get("modal-dialog")) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.age_verification = this.classList.contains("age-verification-modal");
      this.market_verification = this.classList.contains("market-popup-modal");
      this.id = this.getAttribute("id");
      this.popup = this.dataset.popup;
      this.section_id = this.dataset.sectionId;
      this.disabled = this.hasAttribute("disabled");
      this.button = this.querySelector('[id^="ModalClose-"]');

      // Close button setup
      this.button?.addEventListener("click", () => {
        this.hide();
        if (this.requiresCookie()) this.setCookie();
      });

      if (!this.disabled) {
        this.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });
        this.addEventListener("click", (event) => {
          if (event.target === this) this.hide();
        });
      }

      // Show modal if necessary
      if (this.requiresCookie() && !this.getCookie()) {
        this.show();
      }

      // Shopify design mode
      if (Shopify.designMode) {
        document.addEventListener("shopify:section:select", (event) => {
          if (event.detail.sectionId === this.section_id) this.show();
        });
        document.addEventListener("shopify:section:deselect", (event) => {
          if (event.detail.sectionId === this.section_id) this.hide();
        });
      }
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);

      // Localization dropdown listener
      const countrySelect = this.querySelector("#localizationSelect");
      if (countrySelect) {
        countrySelect.addEventListener(
          "change",
          this.onCountrySelectChange.bind(this),
        );
      }
    }

    onCountrySelectChange(event) {
      const selectedCountry = event.target.value;
      const form = document.getElementById("HeaderCountryForm");
      if (form) {
        const hiddenInput = form.querySelector('input[name="country_code"]');
        if (hiddenInput) {
          hiddenInput.value = selectedCountry;
        }
        form.submit();
      }
    }

    show(opener) {
      this.openedBy = opener;
      document.body.classList.add("overflow-hidden");
      this.setAttribute("open", "");
      setTimeout(() => {
        this.querySelector('[role="dialog"]').focus();
      }, 100);
    }

    hide() {
      document.body.classList.remove("overflow-hidden");
      this.removeAttribute("open");
      this.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*",
        );
      });
      this.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      });
      this.querySelectorAll("video").forEach((video) => video.pause());
    }
    requiresCookie() {
      return this.age_verification || this.market_verification;
    }
    getCookie() {
      if (this.requiresCookie()) {
        return window.localStorage.getItem(this.id);
      }
      return null;
    }
    setCookie() {
      if (this.requiresCookie()) {
        window.localStorage.setItem(this.id, "true");
      }
    }
  }
  customElements.define("modal-dialog", ModalDialog);
}
if (!customElements.get("modal-opener")) {
  class ModalOpener extends HTMLElement {
    constructor() {
      super();

      const button = this.querySelector("button");
      if (!button) return;
      button.addEventListener("click", () => {
        const modal = document.querySelector(this.getAttribute("data-modal"));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define("modal-opener", ModalOpener);
}
